import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";
import UnionIcon from "../../../assets/images/icons/Union_5.svg";
import CompanyLocationService from "../../../services/company-location.service";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Select, Switch, Tooltip } from "antd";
import catalogColorstoneService from "../../../services/catalog-colorstone.service";

const AddSingleColorStone = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // ColorStone Data
  const initialState = {
    inventory: "",
    matchedPairStock: "",
    stones: "",
    separable: true,
    size: 0.05,
    cost: 1000,
    shape: "",
    color: "",
    fancyCodes: "",
    fancyNames: "",
    other: "",
    clarity: "",
    cutGrade: "",
    certificate: "",
    certificateNum: "",
    depth: 0,
    table: 0,
    measurements: "",
    polish: "",
    symmetry: "",
    fluorescence: "",
    girdle: "",
    culet: "",
    culetCondition: "",
    crownAngle: 0,
    pavillionAngle: 0,
    comments: "",
    storeLocation: "",
    employeeName: "",
    employeeId: "",
    outOnMemo: true,
    seenByOtherDealers: true,
    addVideo: false,
    TextVideoUrl: "",
    isLabCreated: false,
    fileN: [],
    fileName: "",
    Error: {},
    origin:"",
    treatment:"",
    intensity:"",
    gemType:""
  };
  const [gemstoneData, setgemstoneData] = useState(initialState);
  const [vendorStatusID, setVendorStatusID] = useState(0);
  const [validations, setValidations] = useState({
    inventoryVal: "",
    matchedPairStockVal: "",
    stonesVal: "",
    separableVal: "",
    sizeVal: "",
    costVal: "",
    shapeVal: "",
    colorVal: "",
    fancyCodesVal: "",
    fancyNamesVal: "",
    otherVal: "",
    clarityVal: "",
    cutGradeVal: "",
    certificateVal: "",
    certificateNumVal: "",
    depthVal: "",
    tableVal: "",
    measurementsVal: "",
    polishVal: "",
    symmetryVal: "",
    fluorescenceVal: "",
    girdleVal: "",
    culetVal: "",
    culetConditionVal: "",
    crownAngleVal: "",
    pavillionAngleVal: "",
    commentsVal: "",
    storeLocationVal: "",
    employeeNameVal: "",
    employeeIdVal: "",
    outOnMemoVal: "",
    seenByOtherDealersVal: "",
    addVideoVal: "",
    isLabCreatedVal: "",
    fileNVal: "",
    originVal:"",
    treatmentVal:"",
    gemTypeVal:"",
    intensityVal:"",
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const [DealerId, setDealerId] = useState(null);

  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);
  const [name, setName] = useState();
  const [visible6, setVisible6] = useState(false);
  const [cutList, setCutList] = useState([]);
  const [clarityList, setClarityList] = useState([]);
  const [originList, setOriginList] = useState([]);
  const [gemTypeList, setGemTypeList] = useState([]);
  const [treatmentList, setTreatmentList] = useState([]);
  const [culetList, setCuletList] = useState([]);
  const [intensityList, setIntensityList] = useState([]);
  const [certificateList, setCertificateList] = useState([]);
  const [shapeList, setShapeList] = useState([]);
  const [colorList, setColorList] = useState([]);
  const currency = useSelector((state) => state.loginReducer.currency);
  const currencySymbol =
    currency && currency.substring(currency.lastIndexOf("-") + 1);

  const fancyCodeList = [
    {
      title: "FB",
      value: "FB",
    },
    {
      title: "FBGNY",
      value: "FBGNY",
    },
    {
      title: "FBY",
      value: "FBY",
    },
    {
      title: "FDBGY",
      value: "FDBGY",
    },
    {
      title: "FDBR",
      value: "FDBR",
    },
    {
      title: "FDBY",
      value: "FDBY",
    },
    {
      title: "FDOY",
      value: "FDOY",
    },
    {
      title: "FDY",
      value: "FDY",
    },
    {
      title: "FDYO",
      value: "FDYO",
    },
    {
      title: "FIP",
      value: "FIP",
    },
    {
      title: "FIY",
      value: "FIY",
    },
    {
      title: "FLB",
      value: "FLB",
    },
    {
      title: "FLP",
      value: "FLP",
    },
    {
      title: "FLY",
      value: "FLY",
    },
    {
      title: "FORB",
      value: "FORB",
    },
    {
      title: "FP",
      value: "FP",
    },
    {
      title: "FTP",
      value: "FTP",
    },
    {
      title: "FVY",
      value: "FVY",
    },
    {
      title: "FVYO",
      value: "FVYO",
    },
    {
      title: "FY",
      value: "FY",
    },
    {
      title: "FYB",
      value: "FYB",
    },
    {
      title: "FYD",
      value: "FYD",
    },
    {
      title: "FYE",
      value: "FYE",
    },
    {
      title: "FTD",
      value: "FTD",
    },
    {
      title: "FYI",
      value: "FYI",
    },
    {
      title: "FYL",
      value: "FYL",
    },
    {
      title: "FYO",
      value: "FYO",
    },
    {
      title: "FYV",
      value: "FYV",
    },
    {
      title: "LFY",
      value: "LFY",
    },
    {
      title: "LP",
      value: "LP",
    },
    {
      title: "LPB",
      value: "LPB",
    },
    {
      title: "LYG",
      value: "LYG",
    },
  ];

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.responseData) {
        setDealerId(loginDetials.responseData.dealerId);
        setVendorStatusID(loginDetials?.responseData?.vendorStatusID || 0);
        setName(loginDetials.responseData.dealerName);
        handleGetAllMINEDropDownList(loginDetials.responseData.dealerName);
        handleGetCertificatesForgemstoneCatalogList(
          loginDetials.responseData.dealerName
        );
        handleGetLocationDetails(loginDetials.responseData.dealerId);
      }
    }
  }, []);

  const onCancel = () => {
    setgemstoneData({
      inventory: "",
      matchedPairStock: "",
      stones: "",
      separable: true,
      size: 0.05,
      cost: 1000,
      shape: "",
      color: "",
      fancyCodes: "",
      fancyNames: "",
      other: "",
      clarity: "",
      cutGrade: "",
      certificate: "",
      certificateNum: "",
      depth: 0,
      table: 0,
      measurements: "",
      polish: "",
      symmetry: "",
      fluorescence: "",
      girdle: "",
      culet: "",
      culetCondition: "",
      crownAngle: 0,
      pavillionAngle: 0,
      comments: "",
      storeLocation: "",
      employeeName: "",
      employeeId: "",
      outOnMemo: true,
      seenByOtherDealers: true,
      addVideo: false,
      TextVideoUrl: "",
      isLabCreated: false,
      fileN: [],
      fileName: "",
      Error: {},
      origin:"",
      treatment:"",
      intensity:"",
      gemType:"",
    });
    setValidations({
      inventoryVal: "",
      matchedPairStockVal: "",
      stonesVal: "",
      separableVal: "",
      sizeVal: "",
      costVal: "",
      shapeVal: "",
      colorVal: "",
      fancyCodesVal: "",
      fancyNamesVal: "",
      otherVal: "",
      clarityVal: "",
      cutGradeVal: "",
      certificateVal: "",
      certificateNumVal: "",
      depthVal: "",
      tableVal: "",
      measurementsVal: "",
      polishVal: "",
      symmetryVal: "",
      fluorescenceVal: "",
      girdleVal: "",
      culetVal: "",
      culetConditionVal: "",
      crownAngleVal: "",
      pavillionAngleVal: "",
      commentsVal: "",
      storeLocationVal: "",
      employeeNameVal: "",
      employeeIdVal: "",
      outOnMemoVal: "",
      seenByOtherDealersVal: "",
      addVideoVal: "",
      isLabCreatedVal: "",
      fileNVal: "",
    });
  };

  const onSearch = (val) => {};
  //Onchange Event
  const handleOnChange = (e, isSelect, name) => {
    if (isSelect === "select") {
      setgemstoneData({
        ...gemstoneData,
        [name]: e,
      });
      if (name == "color") {
        setValidations((prevdata) => ({
          ...prevdata,
          colorVal: "",
        }));
      }
      if (name == "clarity") {
        setValidations((prevdata) => ({
          ...prevdata,
          clarityVal: "",
        }));
      }
      if (name == "cutGrade") {
        setValidations((prevdata) => ({
          ...prevdata,
          cutGradeVal: "",
        }));
      }
       if (name == "origin") {
        setValidations((prevdata) => ({
          ...prevdata,
          originVal: "",
        }));
      }
       if (name == "gemtype") {
        setValidations((prevdata) => ({
          ...prevdata,
          gemTypeVal: "",
        }));
      }
       if (name == "treatment") {
        setValidations((prevdata) => ({
          ...prevdata,
          treatmentVal: "",
        }));
      }
       if (name == "intnesity") {
        setValidations((prevdata) => ({
          ...prevdata,
          intensityVal: "",
        }));
      }
      if (name == "shape") {
        setValidations((prevdata) => ({
          ...prevdata,
          shapeVal: "",
        }));
      }
    } else {
      if (e.target.name == "cost") {
        if (e.target.value == "0") {
          e.preventDefault();
        } else {
          setgemstoneData({
            ...gemstoneData,
            [e.target.name]: e.target.value,
          });
        }
      } else {
        setgemstoneData({
          ...gemstoneData,
          [e.target.name]: e.target.value,
        });
      }

      if (e.target.name == "inventory") {
        setValidations((prevdata) => ({
          ...prevdata,
          inventoryVal: "",
        }));
      }
      if (e.target.name == "size") {
        setValidations((prevdata) => ({
          ...prevdata,
          sizeVal: "",
        }));
      }
      if (e.target.name == "cost") {
        setValidations((prevdata) => ({
          ...prevdata,
          costVal: "",
        }));
      }
      if (e.target.name == "stones") {
        setValidations((prevdata) => ({
          ...prevdata,
          stonesVal: "",
        }));
      }
    }
  };

  //Handle Validations
  const handleValidation = () => {
    let isValid = true;
    if (!gemstoneData.inventory) {
      isValid = false;
      validations.inventoryVal = t("Inventory is compulsory");
    } else {
      validations.inventoryVal = "";
    }
    var regex = /^[0-9]+$/;
    if (gemstoneData.stones) {
      if (!gemstoneData.stones.match(regex)) {
        isValid = false;
        validations.stonesVal = t("Stones can only be numbers");
      } else {
        validations.stonesVal = "";
      }
    }
    if (!gemstoneData.size) {
      isValid = false;
      validations.sizeVal = t("Size is compulsory");
    } else {
      validations.sizeVal = "";
    }
    if (!gemstoneData.cost) {
      isValid = false;
      validations.costVal = t("Cost is compulsory");
    } else {
      validations.costVal = "";
    }

    if (!gemstoneData.color) {
      isValid = false;
      validations.colorVal = t("Kindly select the color");
    } else {
      validations.colorVal = "";
    }
    if (!gemstoneData.origin) {
      isValid = false;
      validations.originVal = t("Kindly select the Origin");
    } else {
      validations.originVal = "";
    }
    if (!gemstoneData.intensity) {
      isValid = false;
      validations.intensityVal = t("Kindly select the Intensity");
    } else {
      validations.intensityVal = "";
    }

    if (!gemstoneData.treatment) {
      isValid = false;
      validations.treatmentVal = t("Kindly select the Treatment");
    } else {
      validations.treatmentVal = "";
    }

    if (!gemstoneData.gemType) {
      isValid = false;
      validations.gemTypeVal = t("Kindly select the Gem Type");
    } else {
      validations.gemTypeVal = "";
    }

    if (!gemstoneData.clarity) {
      isValid = false;
      validations.clarityVal = t("Kindly select the clarity");
    } else {
      validations.clarityVal = "";
    }
    if (!gemstoneData.shape) {
      isValid = false;
      validations.shapeVal = t("Kindly select the shape");
    } else {
      validations.shapeVal = "";
    }
    if (
      gemstoneData.employeeId.match(
        /`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\s/g
      ) ||
      gemstoneData.employeeId.match(/^[a-zA-Z]+$/)
    ) {
      isValid = false;
      validations.employeeIdVal =
        "Kindly do not use special characters or alphabets";
    } else {
      validations.employeeIdVal = "";
    }
    setValidations((prevState) => ({
      ...prevState,
      ...validations,
    }));
    return isValid;
  };

  const { Option } = Select;

  const handleSubmit = (e) => {
    e.preventDefault();

  console.log("Button clicked");
    var isValid = handleValidation();
    if (!isValid) {
      return false;
    } else {
      handleSavegemstone();
    }
  };
  const handleVisible6 = () => {
    setVisible6(true);
  };
  const handleOnOk = () => {
    setVisible6(false);
    if (gemstoneData.isLabCreated == true) {
      navigate("/viewMyGemstone");
    } else {
      navigate("/viewMyGemstone");
    }
  };

  const handleGetAllMINEDropDownList = async (id) => {
    try {
      let inputData = {};
      await catalogColorstoneService
        .GetAllDropdownData(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setCutList(responseData.colorStoneCutGrade);
            setClarityList(responseData.clarity);
            setOriginList(responseData.colorStoneOrigin);
            setGemTypeList(responseData.colorStoneGemType);
            setTreatmentList(responseData.colorStonetreatment);
            setCuletList(responseData.colorStoneCulet);
            setIntensityList(responseData.colorStoneIntensity);
            setShapeList(responseData.colorStoneShape);
            setColorList(responseData.colorStoneColor);
          } else {
            setCutList([]);
            setClarityList([]);
            setOriginList([]);
            setGemTypeList([]);
            setTreatmentList([]);
            setCuletList([]);
            setIntensityList([]);
            setShapeList([]);
            setColorList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetCertificatesForgemstoneCatalogList = async (id) => {
    try {
      let inputData = {};
      await catalogColorstoneService
        .GetCertificatesForColorStoneCatalogList(inputData)
        .then((response) => {
          handleGetAllMINEDropDownList();
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            setCertificateList(responseData);
          } else {
            setCertificateList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleSavegemstone = () => {
    setButtonLoading(true);
    const formData = new FormData();

    formData.append("colorStoneDetailList.InventoryOnly", false);
    formData.append("colorStoneDetailList.PublicViewing", false);
    formData.append(
      "colorStoneDetailList.OutonMemo",
      gemstoneData.outOnMemo ? "1" : "0"
    );
    formData.append("colorStoneDetailList.Sold", false);
    formData.append(
      "colorStoneDetailList.InventoryRegion",
      gemstoneData.storeLocation ? gemstoneData.storeLocation : ""
    );
    formData.append("colorStoneDetailList.DealerID", parseInt(DealerId));
    formData.append("colorStoneDetailList.Comments", gemstoneData.comments + "");
    formData.append(
      "colorStoneDetailList.DealerInventoryNo",
      gemstoneData.inventory ? gemstoneData.inventory : ""
    );
    formData.append("colorStoneDetailList.EmployeeName", name ? name + "" : "");
    formData.append(
      "colorStoneDetailList.EmployeeID",
      gemstoneData.employeeId ? gemstoneData.employeeId + "" : ""
    );
    formData.append(
      "colorStoneDetailList.Cut",
      gemstoneData.shape ? gemstoneData.shape + "" : ""
    );
    formData.append(
      "colorStoneDetailList.Measurements",
      gemstoneData.measurements ? gemstoneData.measurements + "" : ""
    );
    formData.append("colorStoneDetailList.Parcel", "");
    formData.append(
      "colorStoneDetailList.TableMeasure",
      gemstoneData.table ? parseFloat(gemstoneData.table) : 0
    );
    formData.append(
      "colorStoneDetailList.Depth",
      gemstoneData.depth ? parseFloat(gemstoneData.depth) : 0
    );
    formData.append(
      "colorStoneDetailList.Color",
      gemstoneData.color ? gemstoneData.color + "" : ""
    );
    formData.append(
      "colorStoneDetailList.ClarityID",
      gemstoneData.clarity ? parseInt(gemstoneData.clarity) : 0
    );
    formData.append(
      "colorStoneDetailList.Size",
      gemstoneData.size ? parseFloat(gemstoneData.size) : 0
    );
    formData.append(
      "colorStoneDetailList.Polish",
      gemstoneData.polish ? gemstoneData.polish + "" : ""
    );
    formData.append(
      "colorStoneDetailList.Symmetry",
      gemstoneData.symmetry ? gemstoneData.symmetry + "" : ""
    );
    formData.append(
      "colorStoneDetailList.Flouresence",
      gemstoneData.fluorescence ? gemstoneData.fluorescence + "" : ""
    );
    formData.append(
      "colorStoneDetailList.Girdle",
      gemstoneData.girdle ? gemstoneData.girdle + "" : ""
    );
    formData.append(
      "colorStoneDetailList.Crown",
      gemstoneData.crownAngle ? gemstoneData.crownAngle + "" : ""
    );
    formData.append(
      "colorStoneDetailList.Culet",
      gemstoneData.culet ? gemstoneData.culet + "" : ""
    );
    formData.append(
      "colorStoneDetailList.Pavillion",
      gemstoneData.pavillionAngle ? gemstoneData.pavillionAngle + "" : ""
    );
    formData.append(
      "colorStoneDetailList.CertificateNo",
      gemstoneData.certificateNum ? gemstoneData.certificateNum + "" : ""
    );
    formData.append(
      "colorStoneDetailList.Stones",
      gemstoneData.stones ? parseInt(gemstoneData.stones) : 0
    );

    formData.append(
      "colorStoneDetailList.CostperCarat",
      gemstoneData.cost ? parseFloat(gemstoneData.cost) : 0
    );
    formData.append("colorStoneDetailList.SellingPrice", 0.0);
    formData.append(
      "colorStoneDetailList.Certificate",
      gemstoneData.certificate ? gemstoneData.certificate + "" : ""
    );
    formData.append(
      "colorStoneDetailList.PairSeparable",
      gemstoneData.separable ? "Yes" : "No"
    );
    formData.append(
      "colorStoneDetailList.PairStockNumber",
      gemstoneData.matchedPairStock ? gemstoneData.matchedPairStock + "" : ""
    );
    formData.append(
      "colorStoneDetailList.CutGrade",
      gemstoneData.cutGrade ? gemstoneData.cutGrade + "" : ""
    );
    formData.append(
      "colorStoneDetailList.CuletCondition",
      gemstoneData.culetCondition + ""
    );
    formData.append(
      "colorStoneDetailList.origin",
      gemstoneData.origin + ""
    );
    formData.append(
      "colorStoneDetailList.treatment",
      gemstoneData.treatment + ""
    );
    formData.append(
      "colorStoneDetailList.gemTypeName",
      gemstoneData.gemType + ""
    );
    formData.append(
      "colorStoneDetailList.FancyColourIntensity",
      gemstoneData.intensity + ""
    );

    formData.append("colorStoneDetailList.CrownPercentage", "");

    formData.append("colorStoneDetailList.PavilionPercentage", "");
    formData.append("colorStoneDetailList.FancyColorMainBody", "");
    formData.append("colorStoneDetailList.FancyColorOvertone", "");
    formData.append("colorStoneDetailList.IsActive", "");
    formData.append("colorStoneDetailList.City", "");
    formData.append("colorStoneDetailList.State", "");
    formData.append("colorStoneDetailList.Country", "");
    formData.append("colorStoneDetailList.IsThirdParty", 0);
    formData.append("colorStoneDetailList.ImageFileName", "");
    formData.append("colorStoneDetailList.IsvideoUrl", gemstoneData.addVideo);
    formData.append("colorStoneDetailList.IsLabCreated", gemstoneData.isLabCreated);
    formData.append(
      "colorStoneDetailList.TextVideoUrl",
      gemstoneData.TextVideoUrl ? gemstoneData.TextVideoUrl + "" : null
    );
    formData.append(
      "colorStoneDetailList.UploadFile",
      gemstoneData.fileN[0] ? gemstoneData.fileN[0] : null
    );
    formData.append("colorStoneDetailList.VideoFileName", "");
    formData.append(
      "colorStoneDealer.dealerId",
      DealerId ? parseInt(DealerId) : 0
    );
    catalogColorstoneService.SaveColorStone(formData)
      .then((response) => {
        var message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(t("Record added successfully."));
          setgemstoneData(initialState);
          handleVisible6();
        } else {
          NotificationManager.error(t("Record not added."));
        }
      })
      .catch((error) => {
        setButtonLoading(false);
        console.log(error);
      })
      .finally(() => {
        setButtonLoading(false);
      });
    console.log(formData, "formDate");
  };

  /*Checkbox change starts*/
  function onChangeCheck(e, name) {
    let tempState = gemstoneData;

    tempState[name] = e.currentTarget.checked;

    setgemstoneData((prevState) => ({
      ...prevState,
      ...tempState,
    }));
  }
  /*Checkbox change ends*/

  const onKeyPressMinusEvent = (e) => {
    if (e.code === "Minus") {
      e.preventDefault();
    }
  };

  // Add Location
  const [LocationDetailsLoader, setLocationDetailsLoader] = useState(true);
  const [locationDetails, setLocationDetails] = useState([]);
  const handleGetLocationDetails = (id) => {
    let inputData = {
      dealerID: id,
    };
    setLocationDetailsLoader(true);
    CompanyLocationService.GetLocationDetails(inputData).then((response) => {
      let message = response.data.message;
      let responseData = response.data.responseData.Table;
      if (message === "Success") {
        setLocationDetailsLoader(false);
        setLocationDetails(responseData);
        if (responseData.length == 1) {
          setgemstoneData((prevState) => ({
            ...prevState,
            storeLocation: response.data.responseData.Table[0].LocationName,
          }));
        }
      }
    });
  };

  return (
    <div className="prodetail__section">
      {vendorStatusID == 3 ? (
        <>{t("Please Contact GemFind to get Access.")}</>
      ) : (
        <div className="form__fields">
          <div className="col-md-12">
            <div className="prod__maindiv data__maping">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="workarea__heading mt-0 mb-3">
                    {" "}
                    {t("Add Gemstone")}{" "}
                  </h4>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label>
                      {" "}
                      {t("Inventory #")}
                      <span className="mandatory">*</span>{" "}
                    </label>
                    <input
                      min="0"
                      placeholder={t("Enter Inventory")}
                      name="inventory"
                      value={gemstoneData.inventory}
                      onChange={(e) => handleOnChange(e, "", "inventory")}
                      className={validations.inventoryVal && "border__red"}
                    />
                    <div>
                      {validations.inventoryVal && (
                        <p className="error-color-red">
                          {validations.inventoryVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Matched Pair Stock #")} </label>
                    <input
                      type="text"
                      placeholder={t("Enter matched stock pair")}
                      name="matchedPairStock"
                      value={gemstoneData.matchedPairStock}
                      onChange={(e) =>
                        handleOnChange(e, "", "matchedPairStock")
                      }
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Stones (Parcel)")} </label>
                    <input
                      min="0"
                      onKeyPress={onKeyPressMinusEvent}
                      placeholder={t("Enter stones")}
                      name="stones"
                      value={gemstoneData.stones}
                      onChange={(e) => handleOnChange(e, "", "stones")}
                      className={validations.stonesVal && "border__red"}
                    />
                    <div>
                      {validations.stonesVal && (
                        <p className="error-color-red">
                          {validations.stonesVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Separable")} </label>
                    <Switch
                      name="separable"
                      checkedChildren={t("Yes")}
                      unCheckedChildren={t("No")}
                      checked={gemstoneData.separable}
                      onChange={(e) => handleOnChange(e, "select", "separable")}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label>
                      {" "}
                      {t("Size")} <span className="mandatory">*</span>
                    </label>
                    <input
                      type="number"
                      min="0.01"
                      step="0.01"
                      onKeyPress={onKeyPressMinusEvent}
                      placeholder={t("Enter the size")}
                      name="size"
                      value={gemstoneData.size}
                      onChange={(e) => handleOnChange(e, "", "size")}
                      className={validations.sizeVal && "border__red"}
                    />
                    <div>
                      {validations.sizeVal && (
                        <p className="error-color-red">{validations.sizeVal}</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block percent__block currency__block">
                    <label>
                      {" "}
                      {t("Cost")} / {t("Carat")}{" "}
                      <span className="mandatory">*</span>
                    </label>
                    <input
                      type="number"
                      min="0"
                      onKeyPress={onKeyPressMinusEvent}
                      placeholder={t("Enter the cost")}
                      name="cost"
                      value={gemstoneData.cost}
                      onChange={(e) => handleOnChange(e, "", "cost")}
                      className={validations.costVal && "border__red"}
                    />
                    <span
                      className="percent__symbol"
                      style={{ left: "6px", right: "0" }}
                    >
                      {currencySymbol}
                    </span>
                    <div>
                      {validations.costVal && (
                        <p className="error-color-red">{validations.costVal}</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label>
                      {" "}
                      {t("Shape")}
                      <span className="mandatory">*</span>{" "}
                    </label>
                    <Select
                      value={gemstoneData.shape ? gemstoneData.shape : null}
                      name="shape"
                      placeholder={t("Select")}
                      onChange={(e) => handleOnChange(e, "select", "shape")}
                      onSearch={onSearch}
                      showSearch
                      optionFilterProp="children"
                      className={
                        validations.shapeVal ? "border__red" : "border__grey"
                      }
                    >
                      <Option>{t("Select")}</Option>
                      {shapeList &&
                        shapeList.map((item, i) => {
                          return (
                            <Option value={item.shapeName}>
                              {item.shapeName}
                            </Option>
                          );
                        })}
                    </Select>
                    <div>
                      {validations.shapeVal && (
                        <p className="error-color-red">
                          {validations.shapeVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label>
                      {" "}
                      {t("Color")} <span className="mandatory">*</span>{" "}
                    </label>{" "}
                    <Select
                      value={gemstoneData.color ? gemstoneData.color : null}
                      name="shape"
                      placeholder={t("Select")}
                      onChange={(e) => handleOnChange(e, "select", "color")}
                      onSearch={onSearch}
                      showSearch
                      optionFilterProp="children"
                      className={
                        validations.colorVal ? "border__red" : "border__grey"
                      }
                    >
                      <Option>{t("Select")}</Option>
                      {colorList &&
                        colorList.map((item, i) => {
                          return (
                            <Option value={item.colorstoneColor}>
                              {" "}
                              {item.colorstoneColor}
                            </Option>
                          );
                        })}
                    </Select>
                    <div>
                      {validations.colorVal && (
                        <p className="error-color-red">
                          {validations.colorVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Other")} </label>
                    <input
                      type="text"
                      placeholder={t("Enter other")}
                      name="other"
                      value={gemstoneData.other}
                      onChange={(e) => handleOnChange(e, "", "other")}
                      className={validations.otherVal && "border__red"}
                    />
                    <div>
                      {validations.otherVal && (
                        <p className="error-color-red">
                          {validations.otherVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label>
                      {" "}
                      {t("Clarity")} <span className="mandatory">*</span>{" "}
                    </label>{" "}
                    <Select
                      value={gemstoneData.clarity ? gemstoneData.clarity : null}
                      name="clarity"
                      placeholder={t("Select")}
                      onChange={(e) => handleOnChange(e, "select", "clarity")}
                      onSearch={onSearch}
                      showSearch
                      optionFilterProp="children"
                      className={
                        validations.clarityVal ? "border__red" : "border__grey"
                      }
                    >
                      <Option> {t("Select")} </Option>
                      {clarityList &&
                        clarityList.map((item, i) => {
                          return (
                            <Option value={item.clarityID}>
                              {" "}
                              {item.claritydetails}
                            </Option>
                          );
                        })}
                    </Select>
                    <div>
                      {validations.clarityVal && (
                        <p className="error-color-red">
                          {validations.clarityVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Certificates")} </label>
                    <Select
                      value={
                        gemstoneData.certificate ? gemstoneData.certificate : null
                      }
                      name="certificate"
                      placeholder={t("Select")}
                      onChange={(e) =>
                        handleOnChange(e, "select", "certificate")
                      }
                      onSearch={onSearch}
                      showSearch
                      optionFilterProp="children"
                      className={
                        validations.certificateVal
                          ? "border__red"
                          : "border__grey"
                      }
                    >
                     
                      {certificateList.map((item, i) => {
                        return (
                          <Option value={item.certificateValue}>
                            {item.certificateValue}
                          </Option>
                        );
                      })}
                      
                    </Select>
                    <div>
                      {validations.certificateVal && (
                        <p className="error-color-red">
                          {validations.certificateVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Certificate #")} </label>
                    <input
                      type="text"
                      placeholder={t("Enter certificate number")}
                      name="certificateNum"
                      value={gemstoneData.certificateNum}
                      onChange={(e) => handleOnChange(e, "", "certificateNum")}
                      className={validations.certificateNumVal && "border__red"}
                    />
                    <div>
                      {validations.certificateNumVal && (
                        <p className="error-color-red">
                          {validations.certificateNumVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                
                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Origin")} </label>
                    <Select
                      value={gemstoneData.origin ? gemstoneData.origin : null}
                      name="origin"
                      placeholder={t("Select")}
                      onChange={(e) => handleOnChange(e, "select", "origin")}
                      onSearch={onSearch}
                      showSearch
                      optionFilterProp="children"
                      className={
                        validations.originVal ? "border__red" : "border__grey"
                      }
                    >
                      <Option> {t("Select")} </Option>
                      {originList &&
                        originList.map((item, i) => {
                          return (
                            <Option value={item.originID}>
                              {" "}
                              {item.originName}
                            </Option>
                          );
                        })}
                    </Select>
                    <div>
                      {validations.originVal && (
                        <p className="error-color-red">
                          {validations.originVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Gem Type")} </label>
                    <Select
                      value={gemstoneData.gemType ? gemstoneData.gemType : null}
                      name="gemType"
                      placeholder={t("Select")}
                      onChange={(e) => handleOnChange(e, "select", "gemType")}
                      onSearch={onSearch}
                      showSearch
                      optionFilterProp="children"
                      className={
                        validations.gemTypeVal ? "border__red" : "border__grey"
                      }
                    >
                      <Option> {t("Select")} </Option>
                      {gemTypeList &&
                        gemTypeList.map((item, i) => {
                          return (
                            <Option value={item.gemtypeValue}>
                              {" "}
                              {item.gemtypeValue}
                            </Option>
                          );
                        })}
                    </Select>
                    <div>
                      {validations.gemTypeVal && (
                        <p className="error-color-red">
                          {validations.gemTypeVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Treatment")} </label>
                    <Select
                      value={gemstoneData.treatment ? gemstoneData.treatment : null}
                      name="treatment"
                      placeholder={t("Select")}
                      onChange={(e) => handleOnChange(e, "select", "treatment")}
                      onSearch={onSearch}
                      showSearch
                      optionFilterProp="children"
                      className={
                        validations.treatmentVal ? "border__red" : "border__grey"
                      }
                    >
                      <Option> {t("Select")} </Option>
                      {treatmentList &&
                        treatmentList.map((item, i) => {
                          return (
                            <Option value={item.treatmentid}>
                              {" "}
                              {item.treatmentvalue}
                            </Option>
                          );
                        })}
                    </Select>
                    <div>
                      {validations.treatmentVal && (
                        <p className="error-color-red">
                          {validations.treatmentVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Intensity")} </label>
                    <Select
                      value={
                        gemstoneData.intensity
                          ? gemstoneData.intensity
                          : null
                      }
                      name="culetCondition"
                      placeholder={t("Select")}
                      onChange={(e) =>
                        handleOnChange(e, "select", "intensity")
                      }
                      onSearch={onSearch}
                      showSearch
                      optionFilterProp="children"
                      className={
                        validations.intensityVal
                          ? "border__red"
                          : "border__grey"
                      }
                    >
                      <Option> {t("Select")} </Option>
                      {intensityList &&
                        intensityList.map((item, i) => {
                          return (
                            <Option value={item.intensityId}>
                              {" "}
                              {item.intensityValue}
                            </Option>
                          );
                        })}
                    </Select>
                    <div>
                      {validations.intensityVal && (
                        <p className="error-color-red">
                          {validations.intensityVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label>
                      {t("Comments")}
                      <Tooltip
                        placement="right"
                        title={t(
                          "Do not include pricing informatin in comments."
                        )}
                      >
                        <img src={UnionIcon} alt="" />
                      </Tooltip>
                    </label>
                    <input
                      type="text"
                      placeholder={t("Enter comments")}
                      name="comments"
                      value={gemstoneData.comments}
                      onChange={(e) => handleOnChange(e, "", "comments")}
                      className={validations.commentsVal && "border__red"}
                    />
                    <div>
                      {validations.commentsVal && (
                        <p className="error-color-red">
                          {validations.commentsVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Store Location")} </label>
                    <Select
                      loading={LocationDetailsLoader}
                      value={
                        gemstoneData.storeLocation
                          ? gemstoneData.storeLocation
                          : ""
                      }
                      name="storeLocation"
                      placeholder={t("Select")}
                      onChange={(e) =>
                        handleOnChange(e, "select", "storeLocation")
                      }
                      onSearch={onSearch}
                      showSearch
                      optionFilterProp="children"
                      className={
                        validations.storeLocationVal
                          ? "border__red"
                          : "border__grey"
                      }
                    >
                      <Option value=""> {t("Select Store Location")} </Option>
                      {locationDetails &&
                        locationDetails.map((item, i) => {
                          return (
                            <Option value={item.LocationName}>
                              {" "}
                              {item.LocationName}
                            </Option>
                          );
                        })}
                    </Select>
                    <div>
                      {validations.storeLocationVal && (
                        <p className="error-color-red">
                          {validations.storeLocationVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Employee Name")} </label>
                    <input
                      type="text"
                      placeholder={t("Enter employee name")}
                      name="employeeName"
                      value={name}
                      onChange={(e) => handleOnChange(e, "", "employeeName")}
                      className={validations.employeeNameVal && "border__red"}
                    />
                    <div>
                      {validations.employeeNameVal && (
                        <p className="error-color-red">
                          {validations.employeeNameVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Employee ID")} </label>
                    <input
                      type="text"
                      placeholder={t("Enter employee id")}
                      name="employeeId"
                      value={gemstoneData.employeeId}
                      onChange={(e) => handleOnChange(e, "", "employeeId")}
                      className={validations.employeeIdVal && "border__red"}
                    />
                    <div>
                      {validations.employeeIdVal && (
                        <p className="error-color-red">
                          {validations.employeeIdVal}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Out On Memo")} </label>
                    <Switch
                      name="out_on_memo"
                      checkedChildren={t("Yes")}
                      unCheckedChildren={t("No")}
                      checked={gemstoneData.outOnMemo}
                      onChange={(e) => handleOnChange(e, "select", "outOnMemo")}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Seen by Other Dealers")} </label>
                    <Switch
                      name="seen_by_other_dealers"
                      checkedChildren={t("Yes")}
                      unCheckedChildren={t("No")}
                      checked={gemstoneData.seenByOtherDealers}
                      onChange={(e) =>
                        handleOnChange(e, "select", "seenByOtherDealers")
                      }
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="input__block">
                    <label> {t("Add Video")} </label>
                    <>
                      <div className="input__block">
                        <input
                          type="text"
                          name="TextVideoUrl"
                          value={gemstoneData.TextVideoUrl}
                          onChange={(e) =>
                            handleOnChange(e, "", "TextVideoUrl")
                          }
                        />
                      </div>
                    </>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="input__block">
                    <label></label>
                    <div className="radio__block">
                      <input
                        type="checkbox"
                        className="w-auto"
                        value={gemstoneData.isLabCreated}
                        onChange={(e) => onChangeCheck(e, "isLabCreated")}
                      />
                      <label> {t("Is Lab Created")} </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row">
                <div className="col-md-12 mt-2">
                  <Button
                    className="primary-btn"
                    onClick={handleSubmit}
                    loading={buttonLoading}
                  >
                    {t("Create")}
                  </Button>
                  <Button
                    onClick={() => onCancel()}
                    className="primary-btn ml-2"
                  >
                    {t("Reset")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* After Delete Modal PopUp Message */}
      <Modal
        title={" "}
        className="modalconsupld__section"
        centered
        visible={visible6}
        onCancel={() => handleOnOk()}
        width={400}
        maskClosable={false}
        footer={[
          <Button key="submit" type="primary" onClick={() => handleOnOk()}>
            {t("OK")}
          </Button>,
        ]}
      >
        <div className="col-lg-12">
          <div className="modal__body">
            <div className="col-lg-12">
              <div className="form__fields border-0 p-0">
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <p>
                      {t(
                        "Your gemstones are Added Successfully. However it will take some moments to Add them from cache."
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* For No dealer Delete */}
    </div>
  );
};

export default AddSingleColorStone;
